export enum PlanMetadataTypes {
    PREVIEW = "PREVIEW",
    PRO = "PRO",
    ENTERPRISE = "ENTERPRISE",
}

export interface PlanMetadata {
    name: string;
    type: PlanMetadataTypes;
    purpose: string;
    price: string;
    period: string | null;
    features: string[];
}

export type ComparisonRow = {
    feature: string;
    description?: string;
    values: [
        string | boolean,
        string | boolean,
        string | boolean,
        string | boolean,
    ];
};
